import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "./../Layout/Header1";
import Footer from "./../Layout/Footer1";
import CountUp from "react-countup";
//Carousel
import TestimonialStyle2 from "./ShortCode/TestimonialStyle2";
import LatestBlogSlider from "./../Element/LatestBlogSlider";
import Index7Slider from "./../Element/Index7Slider";
import { PortfolioItem } from "./ShortCode/ProtfolioStyle3";

//Images
import about1 from "./../../images/about-us/img4.jpg";
import about2 from "./../../images/about-us/img2.jpg";
import about3 from "./../../images/about-us/img3.jpg";

import services1 from "./../../images/our-services/pic1.jpg";
import services2 from "./../../images/our-services/pic2.jpg";
import services3 from "./../../images/our-services/pic3.jpg";
import services4 from "./../../images/our-services/pic4.jpg";
import image1 from "../../images/our-services/logo.jpg";

import pcimg from "./../../images/pc.png";
import bg2 from "./../../images/background/bg2.jpg";
import teamsPictures from "./teamPictures";
import { VisionBlog } from "./Aboutus/Aboutus1";
import Index7ClientCarousel from "../Element/Index7ClientCarousel";
const wraperBlog = [
  { icon: <i className="ti-headphone-alt" />, title: "Learning forecast" },
  { icon: <i className="ti-desktop" />, title: "Computer Engineering" },
  { icon: <i className="ti-ruler-pencil" />, title: "Standard Curiculum" },
];
const wraperBlog2 = [
  { icon: <i className="ti-desktop" />, title: "The Future's Leaders" },
  { icon: <i className="ti-ruler-pencil" />, title: "Impacting Change" },
  {
    icon: <i className="ti-palette" />,
    title: "Solid Relationships that Last",
  },
  { icon: <i className="ti-file" />, title: "Ranks nationally" },
];

const counterBlog1 = [
  {
    icon: <i className="icon flaticon-bar-chart text-primary" />,
    num: "50",
    title: "plus Workshop",
  },
  {
    icon: <i className="icon flaticon-avatar text-primary" />,
    num: "4562",
    title: "Happy Students",
  },
  {
    icon: <i className="icon flaticon-file text-primary" />,
    num: "100",
    title: "plus Resources",
  },
  {
    icon: <i className="icon flaticon-pen text-primary" />,
    num: "5000",
    title: "plus joined University",
  },
];
const dlabBox = [
  {
    icon: <i className="ti-ruler-pencil" />,
    title: "Quality Students",
    image: services1,
  },
  {
    icon: <i className="ti-heart" />,
    title: "Partnership with parents",
    image: services2,
  },
  {
    icon: <i className="ti-brush-alt" />,
    title: "Recognition of the individual",
    image: services3,
  },
  {
    icon: <i className="ti-mouse-alt" />,
    title: "Cooperation",
    image: services4,
  },
];

class Index2 extends Component {
  componentDidMount() {
    var GalleryCategory = document.querySelectorAll(".box-hover");
    var fch = [].slice.call(GalleryCategory);

    for (var y = 0; y < fch.length; y++) {
      fch[y].addEventListener("mouseenter", function () {
        galleryActive(this);
      });
    }

    function galleryActive(current) {
      fch.forEach((el) => el.classList.remove("active"));

      setTimeout(() => {
        current.classList.add("active");
      }, 100);
    }
  }
  render() {
    return (
      <>
        <Header />

        <div className="page-content">
          {/* <ReactRevSlider2 /> */}
          <div className="owl-slider-banner main-slider dz-style-1">
            <Index7Slider />
          </div>
          {/* <!-- About Us --> */}
          <div className="section-full content-inner bg-white">
            <div className="container">
              <div className="max-w800 m-auto text-center">
                <h6>About Juba Proper International College </h6>
                <h4 className="m-b50 ">
                  The corporate vision of Juba Proper International College is
                  to advance knowledge, challenge conventional wisdom, and
                  foster a spirit of innovation and collaboration.
                </h4>
              </div>
              <div className="row">
                {wraperBlog.map((item, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6 m-b30" key={index}>
                    <div className="icon-bx-wraper bx-style-1 p-a30 center fly-box-ho">
                      <div className="icon-sm m-b20">
                        {" "}
                        <Link to={"#"} className="icon-cell">
                          {item.icon}
                        </Link>{" "}
                      </div>
                      <div className="icon-content">
                        <h5 className="dlab-tilte text-uppercase">
                          {item.title}
                        </h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetuer adipiscing
                          elit, sed diam.
                        </p>
                        <Link to={"about-1"} className="site-button">
                          Site Button
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* <!-- About Us End--> */}
          {/* <!-- Services --> */}
          <div className="section-full about-section bg-white">
            <div className="container-fluid">
              <div className="row dzseth">
                <div className="bg-primary col-xl-3 p-a0 col-md-6 col-lg-6 col-xs-12 d-flex dis-tbl">
                  <div className="p-a30 text-white dis-tbl-cell align-self-center">
                    <p className="font-weight-600 m-b10">
                      Employing competent teachers
                    </p>
                    <h4 className="font-weight-700">
                      Extremely well organized with perfect coding
                    </h4>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since. Lorem Ipsum has been the
                      industry's standard dummy text ever since. Lorem Ipsum is
                      simply dummy text.
                    </p>
                    <Link
                      to={"#"}
                      className="site-button white outline outline-2"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 p-a0 col-xs-12 d-flex">
                  <img src={about1} className="abt-img img-cover" alt="" />
                </div>
                <div className="bg-primary col-xl-3 p-a0 col-md-6 col-lg-6 col-xs-12 d-flex dis-tbl">
                  <div className="p-a30 text-white dis-tbl-cell align-self-center">
                    <p className="font-weight-600 m-b10">
                      Administration responsibilities
                    </p>
                    <h4 className="font-weight-700">
                      Extremely well organized with perfect coding
                    </h4>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since. Lorem Ipsum has been the
                      industry's standard dummy text ever since. Lorem Ipsum is
                      simply dummy text.
                    </p>
                    <Link
                      to={"#"}
                      className="site-button white outline outline-2"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 p-a0 col-xs-12 d-flex">
                  <img src={about2} className="abt-img img-cover" alt="" />
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Services END --> */}
          {/* <!-- About Us --> */}
          <div className="section-full content-inner bg-white">
            <div className="container">
              <div className="row m-b50 equal-wraper2">
                <div className="col-xl-6 col-lg-6 col-md-12 equal-col">
                  <img src={about3} className="object-cover radius-sm" alt="" />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 dis-tbl equal-col">
                  <div className="dis-tbl-cell">
                    <h5 className="text-primary m-b5">
                      Juba Proper International College makes preparations
                    </h5>
                    <h2 className="font-weight-500 m-t0 m-b10">
                      How are we getting your kid ready for life after high
                      school and college?
                    </h2>
                    <h6 className="font-weight-400 m-b30">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy.
                    </h6>
                    <div className="row">
                      {wraperBlog2.map((item, index) => (
                        <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                          <div className="icon-bx-wraper  left">
                            <div className="icon-sm text-primary m-b20">
                              <Link to={"#"} className="icon-cell text-primary">
                                {item.icon}
                              </Link>
                            </div>
                            <div className="icon-content">
                              <h5 className="dlab-tilte">{item.title}</h5>
                              <h6 className="font-weight-400">
                                Lorem ipsum dolor sit elit nonummy dolor is.
                              </h6>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="dlab-divider bg-gray-dark">
                <i className="icon-dot c-square"></i>
              </div>
              <div className="row m-t30">
                {counterBlog1.map((data, index) => (
                  <div className="col-lg-3 col-md-6 col-sm-6  m-b30 ">
                    <div className="counter-style-1">
                      <div className="">
                        {data.icon}
                        <span className="counter">
                          <CountUp end={data.num} />
                        </span>
                      </div>
                      <span className="counter-text">{data.title}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* <!-- About Us --> */}
          {/* <!-- Team And Process --> */}
          <div className="section-full bg-black-light content-inner">
            <div className="container">
              <div className="max-w600 m-auto text-center m-b50 text-white">
                <h6 className="font-weight-300 m-t0">Why Choose Us?</h6>
                <h3>
                  Our school is distinguished from others by the following
                  characteristics:
                </h3>
              </div>
              <div className="row">
                {dlabBox.map((item, index) => (
                  <div
                    className="col-lg-3 col-md-6 col-sm-6 col-xs-12"
                    key={index}
                  >
                    <div
                      className="dlab-box-bg m-b30 box-hover"
                      style={{ backgroundImage: "url(" + item.image + ")" }}
                    >
                      <div className="icon-bx-wraper center p-lr20 p-tb30">
                        <div className="text-primary m-b30">
                          <span className="icon-cell icon-sm">{item.icon}</span>
                        </div>
                        <div className="icon-content">
                          <h5 className="dlab-tilte">{item.title}</h5>
                          <p>
                            Lorem Ipsum is simply dummy text of the printing and
                            type setting industry.Lorem Ipsum is simply dummy
                            text.
                          </p>
                        </div>
                      </div>
                      <div className="icon-box-btn text-center">
                        <Link to={"#"} className="site-button btn-block">
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* <!-- Team And Process END --> */}
          {/* mision and vision start */}
          <VisionBlog />
          {/* mision and vision end */}

          {/* <!-- Team Section --> */}
          <div className="section-full text-center bg-white content-inner-1">
            <div className="container">
              <div className="section-head text-black text-center">
                <h2>Meet Our Team</h2>
                <p>
                  Our school is led by a diverse group of educators who have
                  extensive knowledge and experience in their fields.
                </p>
              </div>
              <div className="row">
                {teamsPictures.map((data) => (
                  <div
                    className="col-lg-3 col-md-6 col-sm-6 m-b5"
                    key={data?._id}
                  >
                    <div className="dlab-box">
                      <div className="dlab-media dlab-img-overlay6 dlab-img-effect radius-sm">
                        <img
                          src={!data?.image ? image1 : data?.image}
                          alt={data?.name}
                        />
                        <div className="overlay-bx">
                          <div className="overlay-icon">
                            <ul className="dlab-social-icon">
                              <li>
                                <Link
                                  to={"#"}
                                  className="fa text-white fa-facebook"
                                ></Link>
                              </li>
                              <li>
                                <Link
                                  to={"#"}
                                  className="fa text-white fa-twitter"
                                ></Link>
                              </li>
                              <li>
                                <Link
                                  to={"#"}
                                  className="fa text-white fa-linkedin"
                                ></Link>
                              </li>
                              <li>
                                <Link
                                  to={"#"}
                                  className="fa text-white fa-facebook"
                                ></Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="dlab-title-bx p-a10">
                        <h5 className="text-black m-a0">{data?.name}</h5>
                        <span className="clearfix">
                          Position: {data?.position}
                        </span>
                        <h6
                          className="text-black m-a0"
                          style={{ fontFamily: "Rancho" }}
                        >
                          Education: {data?.education}
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* <!-- Team Section END --> */}
          {/* <!-- Portfolio --> */}
          <div className="section-full bg-white content-inner-1 portfolio">
            <div className="container-fluid">
              <PortfolioItem />
            </div>
          </div>
          {/* <!-- Portfolio End --> */}
          {/* <!-- Map And Form --> */}
          <div className="section-full bg-white content-inner-2 ">
            <div className="container">
              <div className="row equal-wraper3">
                <div className="col-lg-5 equal-col dis-tbl m-b30">
                  <div className="dis-tbl-cell  m-b30">
                    <h2 className="m-t0 m-b10">
                      preparing our students for a more promising future in
                      computer science
                    </h2>
                    <ul className="list-angle-right">
                      <li>Link them to international Program</li>
                      <li>Conduct more workshop in Software Master Classes</li>
                      <li>
                        Give a solide understanding by putting everything in
                        practices
                      </li>
                      <li>Teaching Coding during the Holiday</li>
                      <li>Link them with international Mentors</li>
                    </ul>
                    <Link
                      to={"#"}
                      className="site-button black outline outline-2"
                    >
                      Read More <i className="ti-arrow-right m-l10"></i>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-7 equal-col">
                  <img src={pcimg} alt="" />
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Map And Form END --> */}

          {/* <!-- Clients Words --> */}
          <div
            className="section-full overlay-primary-middle content-inner bg-img-fix"
            style={{ backgroundImage: "url(" + bg2 + ")" }}
          >
            <div className="container">
              <div className="max-w600 m-auto text-center m-b30 text-white">
                <h6 className="m-t0">What people say</h6>
                <h2 className="m-t0">Parents Words</h2>
              </div>
              <div className="section-content m-b30">
                <TestimonialStyle2 />
              </div>
            </div>
          </div>
          {/* <!-- Clients Words END --> */}
          <div className="section-full bg-white content-inner">
            <div className="container">
              <div className="max-w600 m-auto text-center m-b30">
                <h6 className="m-t0">Publish what you think</h6>
                <h2 className="m-t0">Latest Blogs</h2>
              </div>
              <LatestBlogSlider />
            </div>
          </div>
          <div className="section-full bg-primary-dark p-tb15">
            <div className="container">
              <Index7ClientCarousel />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default Index2;
